const formatImage = (x) => {
  return x?.[0]?.file?.file?.[0] || "";
};

export { formatImage };
